import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmailLinkComponent } from './email-link.component';

@NgModule({
  declarations: [EmailLinkComponent],
  imports: [CommonModule],
  exports: [EmailLinkComponent]
})
export class EmailLinkModule {}
